import Route from '@ember/routing/route';

export default class ReportsRoute extends Route {}
